interface ToSafeUrlOptions {
  allowedProtocols?: readonly string[];
  allowProtocolInference?: boolean;
}

const DEFAULT_ALLOWED_PROTOCOLS = ['http:', 'https:'];

function parseUrl(candidate: string): URL | null {
  try {
    return new URL(candidate);
  } catch {
    return null;
  }
}

function isAllowedProtocol(parsedUrl: URL, allowedProtocols: readonly string[]): boolean {
  return allowedProtocols.includes(parsedUrl.protocol);
}

export function toSafeUrl(
  url: string,
  { allowedProtocols = DEFAULT_ALLOWED_PROTOCOLS, allowProtocolInference = false }: ToSafeUrlOptions = {},
): string | null {
  const trimmed = url.trim();

  if (!trimmed) {
    return null;
  }

  const parsedUrl = parseUrl(trimmed);

  if (parsedUrl) {
    return isAllowedProtocol(parsedUrl, allowedProtocols) ? parsedUrl.href : null;
  }

  if (!allowProtocolInference) {
    return null;
  }

  const inferredUrl = parseUrl(`https://${trimmed}`);

  if (!inferredUrl) {
    return null;
  }

  return isAllowedProtocol(inferredUrl, allowedProtocols) ? inferredUrl.href : null;
}